var exports = {
  "kL": "ScopeSheet.module__container___cFB1c0",
  "XG": "ScopeSheet.module__scroller___cFB1c0",
  "iy": "ScopeSheet.module__optionsContainer___cFB1c0",
  "uK": "ScopeSheet.module__option___cFB1c0",
  "h4": "ScopeSheet.module__optionSelected___cFB1c0",
  "ts": "ScopeSheet.module__optionLeft___cFB1c0",
  "H9": "ScopeSheet.module__optionIcon___cFB1c0",
  "AJ": "ScopeSheet.module__optionIconSelected___cFB1c0",
  "re": "ScopeSheet.module__optionText___cFB1c0",
  "ed": "ScopeSheet.module__optionLabel___cFB1c0",
  "tD": "ScopeSheet.module__optionLabelSelected___cFB1c0",
  "q3": "ScopeSheet.module__optionDescription___cFB1c0",
  "oE": "ScopeSheet.module__checkIcon___cFB1c0",
};

module.exports = exports;
